import { Cell } from '@vinted/web-ui';
import Notification from 'components/Notification';
import useTranslate from 'hooks/useTranslate';
import { jsx as _jsx } from "react/jsx-runtime";

const ItemUploadFeedbackNotification = _ref => {
  let {
    handleClose
  } = _ref;
  const translate = useTranslate('item_upload.feedback');
  return /*#__PURE__*/_jsx(Notification, {
    testId: "item-upload--feedback-notification",
    onClose: handleClose,
    body: /*#__PURE__*/_jsx("div", {
      className: "profile__item-upload-feedback-notification",
      children: /*#__PURE__*/_jsx(Cell, {
        theme: "transparent",
        styling: Cell.Styling.Tight,
        title: translate('finalized.title'),
        body: translate('finalized.body')
      })
    }),
    suffix: /*#__PURE__*/_jsx("div", {})
  });
};

export default ItemUploadFeedbackNotification;